export default "__VITE_ASSET__CWtp$APO__"